import { Box, styled } from "@mui/material";

export const HeaderIcon = styled("img")(() => ({}));

export const NavItem = styled(Box)(() => ({
  display: "flex",
  height: "inherit",
  alignItems: "center",
  padding: "0px 30px",
  borderLeft: "1px solid #ffffff1a",
  borderRight: "1px solid #ffffff1a",
  cursor: "pointer",
}));

export const NavItemDataWrapper = styled(Box)(() => ({
  display: "flex",
  gap: "15px",
  height: "inherit",
  alignItems: "center",
  position: "relative",
}));

export const NavbarBrand = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

export const NavItemActiveBar = styled(Box)(({ theme }) => ({
  position: "absolute",
  width: "100%",
  height: "5px",
  bottom: 0,
  background: theme.palette.primary.main,
}));
